import { Pagination } from "@mantine/core";

interface PaginationControlsProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  withEdges?: boolean;
}

const PaginationControls = ({
  currentPage,
  totalPages,
  onPageChange,
  withEdges = false,
}: PaginationControlsProps) => {
  return (
    <Pagination
      value={currentPage}
      onChange={onPageChange}
      total={totalPages}
      withEdges={withEdges}
      sx={(theme) => ({
        ".mantine-Pagination-control": {
          color: "#000000", // Màu chữ mặc định (đen)
          backgroundColor: "transparent", // Nền trong suốt
          border: "1px solid #D1D5DB",
          fontSize: "16px",
          borderRadius: "8px",
          "&:hover": {
            backgroundColor: "#E5F4FE",
            color: "#2A81D0",
          },
        },
        ".mantine-Pagination-control[data-active]": {
          backgroundColor: "#2A81D0",
          color: "#fff",
          pointerEvents: "none",
          "&:hover": {
            backgroundColor: "#2A81D0",
            color: "#fff",
          },
        },
        ".mantine-Pagination-control:first-of-type, .mantine-Pagination-control:last-of-type":
          {
            backgroundColor: "transparent !important",
            "&:hover": {
              backgroundColor: "transparent !important",
            },
          },
      })}
    />
  );
};

export default PaginationControls;
